/**
 * @class CrossBorder
 * @classdesc A class for handling form submission on the cross border disclosure elements
 * @extends Core.Component
 */
export default class CrossBorder extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.forms = el.querySelectorAll('[data-cross-border-form]');
    this.forms.forEach(form => this.events.register(form, 'input', () => form.submit()));
  }
}
